import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const photoCount = 46;
const photos = Array.from({ length: photoCount }, (_, index) => ({
  src: `/assets/galeria/foto-${String(index + 1).padStart(2, '0')}.jpg`,
  alt: `Yasmin - Foto ${index + 1}`,
}));

export default function GallerySection() {
  const [position, setPosition] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);

  const indexAt = (offset: number) => (position + offset + photos.length) % photos.length;
  const previous = () => setPosition((current) => (current - 1 + photos.length) % photos.length);
  const next = () => setPosition((current) => (current + 1) % photos.length);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setPosition((current) => (current + 1) % photos.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const handleTouchEnd = (event: React.TouchEvent) => {
    if (touchStart === null) return;
    const distance = touchStart - event.changedTouches[0].clientX;
    if (Math.abs(distance) > 45) distance > 0 ? next() : previous();
    setTouchStart(null);
  };

  return (
    <section id="galeria" className="gallery-reference">
      <div className="gallery-heading">
        <i className="ri-camera-line" aria-hidden="true" />
        <div className="gallery-title-row"><span /><b>◆◇◆</b><h2>GALERIA DE FOTOS</h2><b>◆◇◆</b><span /></div>
        <p>Um pouco da minha história...</p>
      </div>

      <div
        className="gallery-stage"
        onTouchStart={(event) => setTouchStart(event.touches[0].clientX)}
        onTouchEnd={handleTouchEnd}
      >
        {[-1, 0, 1, 2, 3].map((offset) => {
          const photoIndex = indexAt(offset);
          return (
            <figure className={`gallery-card gallery-card-${offset + 1}`} key={`${position}-${offset}`}>
              <img src={photos[photoIndex].src} alt={photos[photoIndex].alt} loading="lazy" decoding="async" />
            </figure>
          );
        })}
        <button className="gallery-arrow gallery-arrow-left" onClick={previous} aria-label="Foto anterior">
          <i className="ri-arrow-left-s-line" />
        </button>
        <button className="gallery-arrow gallery-arrow-right" onClick={next} aria-label="Próxima foto">
          <i className="ri-arrow-right-s-line" />
        </button>
      </div>

      <div className="gallery-dots" aria-label={`Foto ${position + 1} de ${photos.length}`}>
        {[0, 1, 2, 3].map((dot) => <span className={position % 4 === dot ? 'active' : ''} key={dot} />)}
      </div>
      <svg className="gallery-curve" viewBox="0 0 1440 70" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 8 Q720 112 1440 8" />
      </svg>
      <Link className="gallery-view-more" to="/galeria">VER GALERIA <i className="ri-arrow-right-line" /></Link>
    </section>
  );
}
